export const EN_LANG = "en";
export const PROJECT_LANG = process.env.REACT_APP_LANG_KEY || EN_LANG;
export const LANG_STORAGE_KEY = "nfl_pick_em_lang";

export const isLanguageToggleEnabled = PROJECT_LANG !== EN_LANG;

export const getCurrentLang = (): string => {
	const search = new URLSearchParams(window.location.search);
	const fromUrl = search.get("lang");
	if (fromUrl) {
		return fromUrl;
	}

	if (!isLanguageToggleEnabled) {
		return PROJECT_LANG;
	}

	try {
		const fromStorage = window.localStorage.getItem(LANG_STORAGE_KEY);

		if (fromStorage && [PROJECT_LANG, EN_LANG].includes(LANG_STORAGE_KEY)) {
			return fromStorage;
		}
	} catch {
		// ignore storage access errors
	}

	return PROJECT_LANG;
};

export const setLanguage = (lang: string): void => {
	try {
		window.localStorage.setItem(LANG_STORAGE_KEY, lang);
	} catch {
		// ignore storage access errors
	}

	const url = new URL(window.location.href);
	url.searchParams.set("lang", lang);
	window.location.assign(url.toString());
};
